import { Row, Table } from "react-bootstrap";

import classes from "../../purchase.module.scss";
import OrdersTableHead from "./OrdersTableHead";
import OrdersTableBody from "./OrdersTableBody";

const OrdersTable = ({ base, setBase }) => {
	return (
		<Row className={classes.table}>
			<Table className={classes.table_desktop}>
				<OrdersTableHead base={base} setBase={setBase} />
				<OrdersTableBody base={base} />
			</Table>
		</Row>
	);
};

export default OrdersTable;
